import { CONFIG } from "~/config";
import Scene from "~/scene";
import { store } from "~/state/store";
import { frpc } from "../general";

const URL = "/search";

export function search(query: string, opts: {
	[key: string]: any;
}) {
	const viewport = Scene.getViewport();
	const state = store.getState();
	const { user } = state.user;
	const { zoom } = state.map;
	const conf = {
		page: 0,
		limit: 100,
		pageSize: 10,
		lang: CONFIG.langPriority,
		allowCorr: true,
		autoCorr: true,
		personalize: user.state === "green" ? 1 : 0,
		zoom,
		viewport: {
			fromLongitude: viewport.lbx,
			toLongitude: viewport.rtx,
			fromLatitude: viewport.lby,
			toLatitude: viewport.rty,
		},
		...opts,
	};

	const hints = {};

	if (conf.viewport) {
		hints["3.fromLongitude"] = "float";
		hints["3.toLongitude"] = "float";
		hints["3.fromLatitude"] = "float";
		hints["3.toLatitude"] = "float";
	}

	const limit = conf.limit;

	delete conf.limit;

	return frpc({
		url: CONFIG.requestUrl + URL,
		method: "search",
		args: [query, 0, limit, conf],
		hints,
	});
}
